import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Crosshair } from 'lucide-react';
export const Mechanism = () => {
  return <section className="py-16 md:py-24 bg-[#050508] relative" data-id="element-99">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-101">
          <h2 className="text-3xl sm:text-4xl md:text-5xl mb-4 md:mb-6 px-2" data-id="element-102">
            EL MECANISMO ÚNICO DE RESCATE
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-2xl mx-auto px-2" data-id="element-103">
            Este no es un curso técnico más. Es un sistema de intervención
            psicológica y operativa.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-surface p-6 md:p-8 border-t-4 border-brand-green rounded-b-lg relative overflow-hidden group" data-id="element-105">
            <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-106">
              <ShieldAlert className="w-32 h-32 text-brand-green" data-id="element-107" />
            </div>
            <ShieldAlert className="w-9 h-9 md:w-10 md:h-10 text-brand-green mb-4 md:mb-6" data-id="element-108" />
            <h3 className="text-xl md:text-2xl mb-3 md:mb-4" data-id="element-109">
              El Protocolo de Enfriamiento
            </h3>
            <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-110">
              Desactiva tu respuesta de lucha o huida. Un proceso paso a paso
              para resetear tu sistema nervioso antes de que tomes decisiones
              destructivas.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-surface p-6 md:p-8 border-t-4 border-brand-red rounded-b-lg relative overflow-hidden group" data-id="element-111">
            <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-112">
              <Crosshair className="w-32 h-32 text-brand-red" data-id="element-113" />
            </div>
            <Crosshair className="w-9 h-9 md:w-10 md:h-10 text-brand-red mb-4 md:mb-6" data-id="element-114" />
            <h3 className="text-xl md:text-2xl mb-3 md:mb-4" data-id="element-115">La Matriz 4/30</h3>
            <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-116">
              Te obliga a usar tus indicadores de IA solo en configuraciones de
              "Sniper", donde la probabilidad de éxito es ridículamente alta y
              el riesgo es mínimo.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-8 md:mt-12 text-center p-5 md:p-6 bg-brand-surface/30 border border-white/10 rounded-lg" data-id="element-117">
          <p className="text-base md:text-xl text-white font-medium" data-id="element-118">
            No buscamos un Home Run; buscamos una serie de pequeñas victorias
            quirúrgicas que te devuelvan al punto de equilibrio (Breakeven).
          </p>
        </motion.div>
      </div>
    </section>;
};